import { Form } from "react-bootstrap";
import parse from 'html-react-parser';
import { Org } from "../../interfaces/Org";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";

export interface OrgDeleteProps {
    org: Org;
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function OrgDelete(props: OrgDeleteProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = () => {
        const requestOptionsDelete = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/org/' + props.org._id, requestOptionsDelete)
            .then(response => {
                props.submitCallback(props.org._id);
            })
            .catch(error => {
                navigate('/');
            });
    }

    return(
        <Overlay
            title={t("Delete organization")}
            onClose={handleClose}
            actions={[
                { label: t("Cancel"), variant: "secondary", onClick: handleClose },
                { label: t("Borrar"), variant: "primary", onClick: handleSubmit }
            ]}
        >
            <div className="admin-delete-org-container">
                <Form.Text id="deleteConfirmationMessage">
                    {parse(t("You are about to delete organization content") + ' ' + '<strong>' + props.org.name + '</strong>. ' +
                        t("This action cannot be undone.") + ' ' +
                        t("Are you sure you want to proceed?"))
                    }
                </Form.Text>
            </div>
        </Overlay>
    );
}